export default __webpack_public_path__ + "static/media/withdraw.3336b790.svg";